export var UrlMappings = [
    ['/faq/', "FAQ" /* FAQ */],
    ['/video/', "YouTube Video" /* Video */],
    ['/jabra-glossary', "Jabra Glossary" /* JabraGlossary */],
    ['/hearing-protection', "Hearing Protection" /* HearingProtection */],
    ['/technical-whitepapers', "Technical Whitepapers" /* TechnicalWhitepapers */],
    ['/warranty-terms', "Warranty Terms" /* WarrantyTerms */],
    ['/release-notes/', "Release Notes" /* ReleaseNotes */],
    ['/supportpages/', "Product Support Page" /* ProductSupportPage */],
    ['/business/', "Product Catalog" /* ProductCatalog */],
    ['/bluetooth-headsets/', "Product Catalog" /* ProductCatalog */],
    ['/accessories/', "Product Catalog" /* ProductCatalog */],
];
